import IconType from './iconType';

export default function SearchFTUXIcon({ width = 59, height = 47, color = '#424242', ...rest }: IconType) {
  return (
    <svg width={width} height={height} viewBox="0 0 59 47" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect
        x="0.678943"
        y="0.677966"
        width="56.9492"
        height="12.2034"
        rx="2.0339"
        stroke={color}
        strokeWidth="1.35593"
      />
      <rect
        x="0.678943"
        y="16.9495"
        width="56.9492"
        height="12.2034"
        rx="2.0339"
        stroke={color}
        strokeWidth="1.35593"
      />
      <rect x="0.678943" y="33.22" width="56.9492" height="12.2034" rx="2.0339" stroke={color} strokeWidth="1.35593" />
    </svg>
  );
}
